export default "__VITE_ASSET__DG45nPlI__"